export const Segments = {
  FixterUK: 'FIXTER-UK',
  FixterFR: 'FIXTER-FR',
};
